import { useState, useCallback, useEffect, useRef, useMemo } from 'react'
import { useHistory } from 'react-router-dom'
import { t } from 'ttag'

import { Button } from '@h2/components/buttons/button'
import { Text } from '@h2/components/typography/text'
import { BLACK } from '@h2/components/colors'
import { CogIcon } from '@h2/components/icons/cog'

import { Menu } from './menu'

import { useCallbackOnEventOutside } from '../../hooks/useCallbackOnEventOutside'

const Management = () => {
  const ref = useRef()
  const history = useHistory()
  const [isActive, setIsActive] = useState(false)

  useCallbackOnEventOutside(
    useMemo(() => [ref], [ref]),
    useCallback(() => {
      if (isActive) {
        setIsActive(false)
      }
    }, [isActive, setIsActive])
  )

  useEffect(() => {
    const unlisten = history.listen(() => {
      setIsActive(false)
    })

    return () => unlisten()
  }, [history])

  return (
    <div ref={ref}>
      <Button
        isFullHeight
        icon={CogIcon}
        size="medium"
        variant="outlined"
        fontSize="12px"
        className={isActive ? 'active' : null}
        onClick={() => setIsActive(!isActive)}
        iconAtTop>
        <Text color={BLACK} as="span" size="small">{t`Management`}</Text>
      </Button>
      {isActive && <Menu />}
    </div>
  )
}

export { Management }
